import { render, staticRenderFns } from "./FolderOfferStep4.vue?vue&type=template&id=ae5aae66&scoped=true"
import script from "./FolderOfferStep4.vue?vue&type=script&lang=js"
export * from "./FolderOfferStep4.vue?vue&type=script&lang=js"
import style0 from "./FolderOfferStep4.vue?vue&type=style&index=0&id=ae5aae66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5aae66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})


/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
